import { useQuery } from '@tanstack/react-query';

import { getLocationById } from '../../api/services/Locations';

const LOCATION_QUERY_KEY = 'location';

export function useLocationQuery(locationId: string) {
  const { data, isFetching } = useQuery({
    queryKey: [LOCATION_QUERY_KEY, locationId],
    queryFn: () => getLocationById(locationId),
    enabled: !!locationId,
  });

  const accountLocation = data?.type === 'success' ? data.data.accountLocation : undefined;

  return {
    locationName: accountLocation?.name ?? '',
    riderCount: accountLocation?.passengerCount ?? 0,
    isLoading: isFetching,
  };
}
